import React, {useState} from "react";
import {Typography, TextField, Stack, IconButton, SxProps} from "@mui/material";
import {CancelIcon, ConfirmIcon} from "@components/icons";

type EditableTypographyProps = {
  text: string;
  edit: boolean;
  sx?: SxProps;
  label?: string;
  variant?:
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "subtitle1"
    | "subtitle2"
    | "body1"
    | "body2";
  onConfirm: (t: string) => void;
  onCancel: () => void;
};

const EditableTypography: React.FC<EditableTypographyProps> = ({
  text,
  edit,
  sx,
  label,
  onConfirm,
  onCancel,
  variant = "body1",
}) => {
  const [currentText, setCurrentText] = useState(text);

  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentText(event.target.value);
  };

  return (
    <>
      {edit ? (
        <Stack direction="row" gap={1} alignItems="center">
          <TextField
            label={label}
            value={currentText}
            onClick={e => e.stopPropagation()}
            onKeyDown={e => e.stopPropagation()}
            onKeyUp={e => e.stopPropagation()}
            onChange={handleTextChange}
            autoFocus
            variant="standard"
            size="small"
          />
          <IconButton size="small" onClick={() => onConfirm(currentText)}>
            <ConfirmIcon fontSize="inherit" />
          </IconButton>
          <IconButton size="small" onClick={onCancel}>
            <CancelIcon fontSize="inherit" />
          </IconButton>
        </Stack>
      ) : (
        <Typography variant={variant} style={{cursor: "pointer"}} sx={sx}>
          {text}
        </Typography>
      )}
    </>
  );
};

export {EditableTypography};
